export default "__VITE_ASSET__BCVGMc8w__"